import { useEffect, useState } from 'react';
import logo from '../assets/logo-h.png';
import '../css/Login.css';
import axios from 'axios';
import { eB64, dB64 } from '../shared/Encriptacion';
import { ValidarSesion} from '../shared/Validaciones';

// ================================================================================================
//#region CONTENIDO
// ================================================================================================
export default function Login(){
  useEffect(()=>{
    ValidarSesion();
  },[]);
  return(
    <>
    <div className="container-fluid fondo-login">
      <div className="alert alert-danger credenciales-incorrectas py-3 text-center fw-bold">Credenciales incorrectas</div>
      <div className="row">
        <div className='col-12 col-md-4 contenedor-formulario d-flex align-items-center'>
          <div className='w-100'>
            <div className='d-flex justify-content-center'>
              <img src={logo} alt="Sven S.A.C." className='img-login'/>
            </div>
            <FormularioLogin/>
          </div>
        </div>
        <div className='d-none d-md-block col-md-8 capa-login'>
        </div>
      </div>
    </div>
    </>
  );
}
//#endregion

// ================================================================================================
//#region FORMULARIO LOGIN
// ================================================================================================
function FormularioLogin(){
  //HOOKS DE ESTADO
  const [usuario, setUsuario] = useState('');
  const [pwd, setPwd] = useState('');
  const [mostrarPwd, setMostrarPwd] = useState(false);

  //HANDLERS

  //FUNCIONES
  async function IniciarSesion(){
    const usuarioEnc = eB64(usuario);
    const claveEnc = eB64(pwd);
    const data = {
      usuario: usuarioEnc,
      clave: claveEnc
    }
    try {
      localStorage.clear();
      const respuesta = await axios.post(urlLogin, data);
      const datos = respuesta.data;
      if (datos.mensajeError == null) {
        localStorage.setItem("r1",datos.r1);
        localStorage.setItem("r2",datos.r2);
        localStorage.setItem("r3",datos.r3);
        localStorage.setItem("r4",datos.r4);
        localStorage.setItem("r5",datos.r5);
        localStorage.setItem("r6",datos.r6);
        ValidarSesion();
      } else {
        CredencialesIncorrectas(datos.mensajeError);
      }
    } catch (error) {
      localStorage.clear();
      if (error.response && error.response.data) {
        console.error("Error en la solicitud:", error.response.data);
      } else {
        console.error("Error desconocido:", error.message);
      }
    }
  }

  return(
      <>
      <div>
          <form onSubmit={e => {
            e.preventDefault();
            IniciarSesion(usuario, pwd);
          }}>
              <div className="input-group p-4" >
                  <span className="input-group-text" id="texto-usuario">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person-fill" viewBox="0 0 16 16">
                      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
                  </svg>
                  </span>
                  <input required type="text" className="form-control" aria-describedby="texto-usuario" onChange={e=>{
                      setUsuario(e.target.value);
                  }} />
              </div>
              <div className="input-group p-4">
                  <span className="input-group-text" id="texto-pwd">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-key-fill" viewBox="0 0 16 16">
                          <path d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                      </svg>
                  </span>
                  <input required type={mostrarPwd ? 'text':'password'} className="form-control" aria-describedby="texto-pwd" onChange={
                      e=>{
                          setPwd(e.target.value);
                      }}/>
              </div>
              <div className="d-flex justify-content-end px-4" >
                  <div className="form-check">
                  <input className="form-check-input" type="checkbox" defaultValue id="flexCheckDefault" onChange={()=>{
                      setMostrarPwd(!mostrarPwd);
                  }}/>
                  <label className="form-check-label text-white" htmlFor="flexCheckDefault">
                      Mostrar contraseña
                  </label>
              </div>
              </div>
              <div className="py-4 d-flex justify-content-center">
                  <button className="btn btn-dark btn-lg">Iniciar sesión</button>
              </div>
          </form>
      </div>
      </>
  );
}
//#endregion

// ================================================================================================
//#region CREDENCIALES INCORRECTAS
// ================================================================================================
function CredencialesIncorrectas(mensaje){
  let elemento = document.querySelector('.credenciales-incorrectas');
  elemento.innerHTML=mensaje;
  elemento.setAttribute('style','top:0px');
  setTimeout(()=>{
      document.querySelector('.credenciales-incorrectas').setAttribute('style','top:-100px');
  },2000);
}
//#endregion

// ================================================================================================
//#region CONSTANTES
// ================================================================================================
const urlLogin = process.env.REACT_APP_URL_LOGIN;
//#endregion